import { createContext, useContext, useRef } from 'react';
import { ApplyModal } from './apply-modal';
import type { ReactNode } from 'react';
import type { ApplyModalHandle } from './apply-modal';

interface ApplyModalContextValue {
  openApplyModal: () => void;
}

const ApplyModalContext = createContext<ApplyModalContextValue | null>(null);

export function ApplyModalProvider({ children }: { children: ReactNode }) {
  const modalRef = useRef<ApplyModalHandle>(null);

  return (
    <ApplyModalContext.Provider value={{ openApplyModal: () => modalRef.current?.open() }}>
      {children}
      <ApplyModal ref={modalRef} />
    </ApplyModalContext.Provider>
  );
}

export function useApplyModal(): ApplyModalContextValue {
  const ctx = useContext(ApplyModalContext);
  if (!ctx) throw new Error('useApplyModal must be used within ApplyModalProvider');
  return ctx;
}
